import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
} from '@fluentui/react-components';
import { DeleteRegular } from '@fluentui/react-icons';
import { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  STATUS_COMPLETED,
  STATUS_DELETED,
  STATUS_FAILED,
  STATUS_MEASURING,
  STATUS_RUNNING,
  STATUS_SCHEDULED,
} from '../statuses';

const nonDeletableStatuses = [
  STATUS_RUNNING,
  STATUS_MEASURING,
];

export const DeleteStudyDialog = ({ onDelete, name, status }) => {
  const i18n = useContext(I18nContext);
  const description = i18n.getString(_TL_('Are you sure you want to delete the lift study, {{name}}?'), { name });
  const deleteButtonLabel = i18n.getString(_TL_('Delete'));
  const closeButtonLabel = i18n.getString(_TL_('Close'));
  return (
    <Dialog>
      <DialogTrigger disableButtonEnhancement>
        <Button
          aria-label={i18n.getString(_TL_('Delete'))}
          disabled={nonDeletableStatuses.includes(status)}
          icon={<DeleteRegular />}
          className="delete-experiment-modal"
        />
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.getString(_TL_('Delete Lift Study'))}</DialogTitle>
          <DialogContent>
            {description}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" aria-label={closeButtonLabel}>{closeButtonLabel}</Button>
            </DialogTrigger>
            <Button
              className="delete-experiment"
              appearance="primary"
              onClick={() => onDelete()}
              aria-label={deleteButtonLabel}
            >{deleteButtonLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

DeleteStudyDialog.propTypes = {
  onDelete: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.oneOf([
    STATUS_COMPLETED,
    STATUS_DELETED,
    STATUS_FAILED,
    STATUS_MEASURING,
    STATUS_RUNNING,
    STATUS_SCHEDULED,
  ]).isRequired,
};
